import { createBrowserHistory, createMemoryHistory } from 'history';

// Use memory history in test environment to avoid JSDOM issues
const history = globalThis.window?.document 
  ? createBrowserHistory()
  : createMemoryHistory();

export default history;
